// extracted by mini-css-extract-plugin
export default {"feedbackMenu":"FeedbackMenu-feedbackMenu--071ab","feedbackMenu__brandUpdate":"FeedbackMenu-feedbackMenu__brandUpdate--b8d06"};